// import { showLoading, hideLoading } from 'react-redux-loading-bar';
import { getUniversityInfo, editUniversityInfo } from '../api/university';

export const GET_UNIVERSITY = 'GET_UNIVERSITY';
export const EDIT_UNIVERSITY = 'EDIT_UNIVERSITY';

function getUniversity (university, error=null) {
    return {
        type: GET_UNIVERSITY,
        university,
        error
    }
}

export function handleGetUniversity(id) {
    return async (dispatch, getState) => {
        // dispatch(showLoading())
        try {
            const result = await getUniversityInfo(id, getState().authedUser.token);
            if(result){
                const university = result.data.data;
                // dispatch(hideLoading())
                return dispatch(getUniversity(university));
            }  else {
                // dispatch(hideLoading())
                return dispatch(getUniversity(null, "Unknown error"));
            }
        } catch (error) {
            // dispatch(hideLoading())
            return dispatch(getUniversity(null, error));
        }
    }
}

// function editUniversity (university, error=null) {
//     return {
//         type: EDIT_UNIVERSITY,
//         university,
//         error
//     }
// }

export function handleEditUniversity(id,data) {
    return async (dispatch, getState) => {
        // dispatch(showLoading())
        try {
            const result = await editUniversityInfo(id,data, getState().authedUser.token);
            if(result){
                console.log(id, data)
                console.log(result)
                const university = result.data.data;
                // dispatch(hideLoading())
                return dispatch(getUniversity(university));
            }  else {
                // dispatch(hideLoading())
                return dispatch(getUniversity(null, "Unknown error"));
            }
        } catch (error) {
            // dispatch(hideLoading())
            return dispatch(getUniversity(null, error));
        }
    }
}

// Emptying the University store
export function restoreUniversity() {
    return async (dispatch) => {
        return dispatch(getUniversity(null));
    }
}